import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
    { label: "Hoe het werkt", target: "#hoe-het-werkt", testId: "nav-link-hoe-het-werkt" },
    { label: "Features", target: "#features", testId: "nav-link-features" },
    { label: "Prijzen", target: "#prijzen", testId: "nav-link-prijzen" },
    { label: "FAQ", target: "#faq", testId: "nav-link-faq" },
];

const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (target) => {
        setOpen(false);
        scrollToSection(target);
    };

    return (
        <motion.header
            data-testid="main-nav"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled || open
                    ? "backdrop-blur-xl bg-black/60 border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={() => go("#top")}
                    aria-label="MeerjarenplanOnline.nl"
                >
                    <img src="/images/logo.png" alt="MeerjarenplanOnline.nl" className="h-7 w-auto" />
                </button>

                <nav className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button
                            key={l.target}
                            data-testid={l.testId}
                            onClick={() => go(l.target)}
                            className="text-xs tracking-[0.2em] uppercase font-bold text-white/60 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </button>
                    ))}
                    <a
                        data-testid="nav-link-contact"
                        href="/community"
                        className="text-xs tracking-[0.2em] uppercase font-bold text-white/60 hover:text-white transition-colors duration-300"
                    >
                        Contact
                    </a>
                </nav>

                <div className="flex items-center gap-3">
                    <button
                        data-testid="nav-menu-button"
                        onClick={() => setOpen(!open)}
                        className="md:hidden text-white p-2"
                        aria-label="Menu"
                    >
                        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div data-testid="nav-mobile-menu" className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {LINKS.map((l) => (
                            <button
                                key={l.target}
                                data-testid={`${l.testId}-mobile`}
                                onClick={() => go(l.target)}
                                className="text-left text-white/80 text-sm tracking-[0.2em] uppercase font-bold"
                            >
                                {l.label}
                            </button>
                        ))}
                        <a
                            data-testid="nav-link-contact-mobile"
                            href="/community"
                            className="text-left text-white/80 text-sm tracking-[0.2em] uppercase font-bold"
                        >
                            Contact
                        </a>
                    </div>
                </div>
            )}
        </motion.header>
    );
};

export default Nav;
